import { IResearchWorkItem } from "features/Research/types";
import { apiClient } from "lib/apiClient";

export interface IResearchAssignmentRequest {
  workItemId: string;
  version: number;
  userId: string | null;
  reason?: string;
}

export const assignResearchWorkItem = async ({
  workItemId,
  version,
  userId,
  reason,
}: IResearchAssignmentRequest): Promise<IResearchWorkItem> => {
  const response = await apiClient.put(
    `/research/work-items/${workItemId}/assignment`,
    { version, userId, reason }
  );

  return response.data;
};
